// extracted by mini-css-extract-plugin
export default {"svgIcon":"SvgIcon_svgIcon__ltCno"};